import { render, staticRenderFns } from "./data9.vue?vue&type=template&id=5b099106&scoped=true"
import script from "./data9.vue?vue&type=script&lang=js"
export * from "./data9.vue?vue&type=script&lang=js"
import style1 from "./data9.vue?vue&type=style&index=1&id=5b099106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b099106",
  null
  
)

export default component.exports